import React from 'react';

export const getDisclaimerMessage = (disclaimerText, primaryComponent) => {
    const carepackBundleQuantity = (primaryComponent?.quantity || 1) * 1;
    return primaryComponent ? (
        <ul className="pdp-carepack-module-disclaimer">
            <li>
                {!carepackBundleQuantity || carepackBundleQuantity === 1 ? (
                    <>
                        {`HP Care Pack applies only to the primary item in this bundle `}
                        <strong>{`(${primaryComponent.name})`}</strong>
                    </>
                ) : (
                    <>
                        {`*HP Care Pack `}
                        <strong>applies only</strong>
                        {` to primary items in this bundle `}
                        <strong>{`(${primaryComponent.name})`}</strong>
                        {`. Therefore, a separate HP Care Pack will be added for each `}
                        <strong>{`${primaryComponent.name}`}</strong>
                        {` in the bundle.`}
                    </>
                )}
            </li>
            <li>{disclaimerText}</li>
        </ul>
    ) : (
        disclaimerText
    );
};
